var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8333 11.3889V14.3519C16.8333 14.7448 16.6772 15.1216 16.3994 15.3994C16.1216 15.6772 15.7448 15.8333 15.3519 15.8333H4.98148C4.58857 15.8333 4.21175 15.6772 3.93392 15.3994C3.65608 15.1216 3.5 14.7448 3.5 14.3519V11.3889M6.46296 7.68519L10.1667 11.3889M10.1667 11.3889L13.8704 7.68519M10.1667 11.3889V2.5",
    stroke: "#725798",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.fc2040b6a2b0ad4475e86235f7de3e3b.svg";
export { ForwardRef as ReactComponent };